import { jsxs, jsx } from 'react/jsx-runtime';
import cx from 'classnames';
import classes from './Step.module.scss.js';
import img from '../../../assets/images/icons/tick.svg.js';

const Step = ({ className = "", circleClassName = "", stepNumber = 1, title = "", isActive = false, isDone = false, }) => (jsxs("div", { className: cx(classes.step, className, { [classes.active]: isActive, [classes.done]: isDone }), children: [jsxs("div", { className: cx(classes.circle, circleClassName), children: [jsx("span", { className: classes.number, children: stepNumber }), jsx("img", { alt: title, className: classes.tick, src: img })] }), jsx("span", { className: classes.title, children: title })] }));

export { Step as default };
